<template lang="pug">
#selecionar-car
    .fields
        .input-field
            i.el-icon-search
            input(
                :placeholder='$t("laudos.digiteONumeroDoCar ")',
                v-mask='`XX-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX`',
                v-model='carSelecionado',
                type='text',
                @input='handlerCarSelecionado',
                @keyup.enter='buscarCar'
            )
        .obersvacao
            el-input.textarea(
                v-model='dados.observacao',
                :placeholder='$t("laudos.observacao")',
                type='textarea',
                :maxlength='500',
                resize='none'
            )
            span.length {{ dados.observacao.length }}/500
    .dados-car(v-if='mostrarDados')
        h3.dados-car__title {{ $t('laudos.informacoesDoCar') }}
        span.dados-car__lable {{ `${$t('laudos.codigo')}: ` }}
            span.dados-car__text {{ carDados.codigo }}
        span.dados-car__lable {{ `${$t('laudos.areaHa')}: ` }}
            span.dados-car__text {{ carDados.areaHa }}
        span.dados-car__lable {{ `${$t('mensagens.comuns.municipioUf')}: ` }}
            span.dados-car__text {{ carDados.municipioUF }}
        span.dados-car__lable {{ `${$t('laudos.situacao')}: ` }}
            span.dados-car__text {{ carDados.situacao }}
    el-divider.custom-divider
    .footer(slot='footer')
        BaseButton(type='outline', @click='cancelarModal') {{ $t('mensagens.comuns.cancelar') }}
        BaseButton(
            type='primary',
            @click='cadastrarLaudos',
            :disabled='isValid'
        ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import UtilsService from '@/modules/laudos/services/UtilsService';
import formatters from '@/modules/laudos/utils/formatters';
import LaudosService from '@/modules/laudos/services/LaudosService';
import StatusCar from '@/constants/StatusCar';
import CarUtils from '@/modules/laudos/utils/CarUtils';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

export default {
    name: 'SelecionarCar',
    emits: ['cancelar-modal', 'getLaudos'],
    components: {
        BaseButton
    },
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            mostrarDados: false,
            carDados: {},
            carSelecionado: '',
            existeCarNaBase: false,
            timeDebounce: 0,
            dados: {
                observacao: ''
            }
        };
    },
    computed: {
        isValid() {
            return !(this.carSelecionado && this.existeCarNaBase);
        }
    },
    methods: {
        debounceBuscarCar() {
            this.existeCarNaBase = false;
            this.mostrarDados = false;
            clearTimeout(this.timeDebounce);

            if (this.carSelecionado === this.carDados?.codigo) {
                this.mostrarDados = true;
                this.existeCarNaBase = true;
                return;
            }

            this.timeDebounce = setTimeout(() => {
                const formatoCarValido = CarUtils.isCar(this.carSelecionado);

                if (formatoCarValido) {
                    this.buscarCar();
                }
            }, 1000);
        },
        handlerCarSelecionado(event) {
            const value = event.target.value;
            const formatoCarValido = value && CarUtils.isCar(value);

            if (formatoCarValido) {
                this.buscarCar();
            }
        },
        async buscarCar() {
            const formatoCarInvalido = !CarUtils.isCar(this.carSelecionado);

            if (formatoCarInvalido) {
                return this.$notify.warning({
                    message: this.$t('laudos.erro.carInvalido')
                });
            }

            try {
                const car = this.carSelecionado;
                const { data } = await UtilsService.getDadosCARSemGeometria(
                    car
                );

                this.carDados = {
                    areaHa: formatters.formatNumber(data.areaHa, 2),
                    municipioUF: `${data.nomeMunicipio}/${data.uf}`,
                    situacao: StatusCar[data.situacao],
                    condicao: data.situacao,
                    codigo: data.codigo
                };
                this.mostrarDados = true;
                this.existeCarNaBase = true;
            } catch (error) {
                this.carDados = null;
                this.existeCarNaBase = false;
                this.mostrarDados = false;
                this.$notify.error({
                    message: this.$t('laudos.erro.ocorreuUmErroAoBuscarCar')
                });
                throw error;
            }
        },
        async cadastrarLaudos() {
            const informacaoLaudos = [
                {
                    car: {
                        codigo: this.carDados.codigo,
                        condicao: this.carDados.condicao
                    },
                    observacao: this.dados.observacao || null,
                    tipoLaudoId: this.tipoLaudo
                }
            ];

            try {
                await LaudosService.cadastrarLaudos({ informacaoLaudos });
                this.$notify.success({
                    message: this.$t('laudos.solicitacaoRealizadaComSucesso')
                });
                this.$emit('getLaudos');
                this.cancelarModal();
            } catch (error) {
                this.$notify.error({
                    message: error.message
                });
            }
        },
        cancelarModal() {
            this.$emit('cancelar-modal');
        }
    }
};
</script>

<style lang="scss" scoped>
#selecionar-car {
    .fields {
        display: flex;
        flex-direction: column;
        gap: 16px;
        width: 100%;
        .obersvacao {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            width: 50%;
            gap: 4px;
            .textarea {
                width: 100%;
            }
            .length {
                font-size: 12px;
                color: var(--primary);
            }
        }
        .input-field {
            height: 40px;
            border-radius: 4px;
            width: 50%;
            display: flex;
            justify-content: center;
            border: 1px solid #dcdfe6;

            i.el-icon-search {
                color: var(--gray);
                font-size: 16px;
                display: flex;
                align-items: center;
                margin: 0 8px;
            }

            input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                margin: 0;
                padding: 0;
                color: var(--text-disabled);
                &::placeholder {
                    color: #c0c4cc;
                }
            }
            &:focus-within {
                border: 1px solid var(--primary);
            }
        }
    }
    .dados-car {
        color: var(--primary);
        width: 100%;
        margin: 16px 0;
        display: flex;
        flex-direction: column;
        &__title {
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 8px;
        }
        &__lable {
            font-size: 14px;
            font-weight: 600;
        }
        &__text {
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 2px;
        }
    }
    .footer {
        display: flex;
        justify-content: space-between;
        gap: 16px;
    }

    .custom-divider {
        margin: 16px 0 !important;
    }
}
</style>
